var ctrlopt = ctrlopt || undefined,
    site = site || {},
  Drupal = Drupal || {};

Drupal.appointmentBooking = Drupal.appointmentBooking || {};


(function ($) {
  "use strict";
  
  if (typeof ctrlopt === 'undefined' || ctrlopt === null || ctrlopt !== Object(ctrlopt)) {
    throw new Error("ctrlopt library is required to use appointment booking library");
  }
  
  var apptBook = Drupal.appointmentBooking;
  var tmspageData;
  tmspageData = typeof tms_page_data != 'undefined' ? tms_page_data : {};
  /**
   * apptBook.sectionModel
   *  A singleton that is the model in an MVC pattern. The sectionModel singleton controls the state of the
   *  Appointment Booking flow as well as provides utility methods for making calls to the API and retrieving data
   *
   *
   **/

  apptBook.sectionModel = $.extend(Object.create(new ctrlopt.Publisher()), {
    dataSet: false,
    countersData: null,
    servicesData: null,
    appointmentsData: null,
    confirmationData: null,
    token: null,

    setData: function (options) {
      if (this.dataSet || !options || !options.data) {
        return;
      }
      var me = this;
      this.sectionsData = options.data;
      if(options.token) {
        this.token = options.token;
        this.dataSet = true;
        this.fire("data_set");
      } else {
        this.updateAuthToken(function () {
          me.dataSet = true;
          me.fire("data_set");
        });
      }
    },

    findSectionIndex: function (id) {
      for (var i = 0, len = this.sectionsData.length; i < len; i += 1) {
        if (this.sectionsData[i].id === id) {
          return i;
        }
      }
      return 0;
    },

    update: function (data) {
      if (!this.dataSet || !data) {
        return;
      }

      var updateData, sectIndex, nextSectId, nextSectIndex,
        sectData = data.params || {};

      if (!data.sectionId) {
        nextSectIndex = 0;
        nextSectId = this.sectionsData[nextSectIndex].id;
      } else if (data.sectionId === 'next' || data.sectionId === 'previous') {
        nextSectIndex = (data.sectionId === 'next') ? this.currentIndex + 1 : this.currentIndex - 1;
        nextSectId = this.sectionsData[nextSectIndex].id;
      } else {
        nextSectId = data.sectionId;
        nextSectIndex = this.findSectionIndex(nextSectId);
      }



      updateData = {
        sectionId: nextSectId,
        sectionIndex: nextSectIndex,
        lastSectionIndex: this.currentIndex,
        params: sectData,
        isHistory: data.isHistory
      };

      this.currentIndex = nextSectIndex;
      this.currentId = nextSectId;

      this.dispatchUpdate(updateData);
    },

    dispatchUpdate: function (data) {
      this.fire('update', data);
    },

    getData: function () {
      return (this.dataSet) ? this.sectionsData : null;
    },

    getSectionData: function (id) {
      var i;
      if (!id) {
        id = this.currentId;
      }

      i = this.findSectionIndex(id);

      return this.sectionsData[i];
    },

    getAuthToken: function () {
      return this.token;
    },

    setAuthToken: function (token) {
      this.token = token;
    },

    updateAuthToken: function (callback) {
      var me = this;
      generic.jsonrpc.fetch({
        method: "appointmentbooking.getauthtoken",
        onSuccess: function (rpc) {
          var val = rpc.getValue();
          me.token = val.auth_token;
          if (typeof callback === 'function') {
            callback(me.token)
          }
          me.fire("auth_token_update", me.token);
        },
        onError: function (rpc) {
          //console.log("Error getting authorization token");
        }
      });
    },


    makeAPICall: function (url, method, params, callback, errorCallback) {
      if (!this.token) {
        throw new Error("Call to SectionModel.makeAPICall will not work if Authorization Token has not been set first.");
      }

      if (typeof url !== 'string') {
        throw new Error("Call to SectionModel.makeAPICall requires a url argument that is a string.");
      }
      if (typeof method === "function") {     //// This means no method arg, callback is second
        if (typeof params === "function") {
          errorCallback = params;
          params = {};
        }
        callback = method;
      }

      if (typeof params === "function") {     //// This means no method arg, callback is second
        if (typeof callback === "function") {
          errorCallback = callback;
        }
        callback = params;
        params = {};
      }

      if (typeof method !== "string") {
        method = "GET";
      }

      if (params === null || (typeof params !== 'object' || params !== Object(params))) {
        params = {};
      }

      var me = this,
        cbIsFunc = typeof callback === 'function',
        ecbIsFunc = typeof errorCallback === 'function';

      params.token = this.token;
      if (Drupal.settings.globals_variables.set_appt_lang) {
        var languageCode = this.getLanguage();
        if (languageCode) {
          params.lang = languageCode;
        }
      }

      $.ajax(
        {
          url: url,
          type: method,
          data: params,
          success: function (r) {
            if (cbIsFunc) {
              callback(r);
            }
          },

          error: function (err) {
            //console.log("API Call Error: " + err.status);
            //console.log("API Call Error: " + err.responseText);
            var r,
              cType = err.getResponseHeader('content-type');

            if(cType && cType === "application/json")  {
              r = JSON.parse(err.responseText);
            }

            if (ecbIsFunc) {
              errorCallback(r);
            }
          }
        }
      );
    },

    fetchCountersData: function (params, callback) {
      var myCallBack,
        url = 'https://' + window.location.hostname + '/_abapi/api/v1/counters?sortOutputBy=town',
        me = this,
        virtualLocationMessage,
        cbIsFunc = (typeof callback === 'function');

        virtualLocationMessage = function () {
          var findStoreNumber = $('.appt-book-location-selector')?.data('virtual_store_querystring_value')?.toString() || '';

          $('.js-virtual__appointment--button').addClass('no_services');
          if (findStoreNumber) {
            me.countersData.forEach((storeCounter) => {
              if (storeCounter.store_no === findStoreNumber) {
                $('.js-virtual__appointment--button').removeClass('no_services');
              }
            });
          }
        };
      if (!this.token) {
        throw new Error("Call to SectionModel.fetchCountersData will not work if Authorization Token has not been set first.");
      }
      if (!params || !params.service_id) {
        myCallBack = function (response) {
          me.countersData = response;
          if (cbIsFunc) {
            callback(response);
          }
          virtualLocationMessage();
          me.fire("counters_data", response);
        }
      } else {
        myCallBack = function (response) {
          if (cbIsFunc) {
            callback(response);
          }
          me.fire('counters_data', response);
        }
      }
      this.makeAPICall(url, 'GET', params, myCallBack);
    },


    getCounters: function (callback) {
      var cbIsFunc = (typeof callback === 'function'),
        me = this;

      if (this.countersData) {
        if (cbIsFunc) {
          callback(this.countersData);
        }
      } else {
        this.fetchCountersData({lite: 1}, callback);
      }

      return this.countersData;  //should return null if countersData is not populated yet
    },


    fetchCounterData: function (counterId, params, callback) {
      var myCallBack, url,
        me = this,
        cbIsFunc = (typeof callback === 'function');

      if (!this.token) {
        throw new Error("Call to SectionModel.fetchCounterData will not work if Authorization Token has not been set first.");
      }
      if (typeof counterId !== 'string' && typeof counterId !== 'number') {
        throw new Error("Call to SectionModel.fetchCounterData requires counterId argument that is either a string or a number.");
      } else {
        url = 'https://' + window.location.hostname + '/_abapi/api/v1/counters/' + counterId;
      }

      myCallBack = function (response) {
        if (cbIsFunc) {
          callback(response);
        }
        me.fire("counter_data", response);
      };

      this.makeAPICall(url, 'GET', params, myCallBack);
    },


    getCounter: function (counterId, params, callback) {
      var cd,
        response = null;


      if (typeof counterId !== 'string' && typeof counterId !== 'number') {
        throw new Error("Call to SectionModel.getCounter requires counterId argument that is either a string or a number.");
      }

      if (typeof params === 'function') {
        callback = params;
        params = null;
      }

      if (typeof callback === 'function') {
        this.fetchCounterData(counterId, params, callback);
      }

      if (this.countersData) {
        for (var i = this.countersData.length - 1; i >= 0; i -= 1) {
          cd = this.countersData[i];
          if (parseInt(cd.id, 10) === parseInt(counterId, 10)) {
            response = cd;
            break;
          }
        }
      }

      return response;
    },


    getCounterServices: function (counterId, callback) {
      var cd,
        response = null,
        cbIsFunc = (typeof callback === 'function');


      if (typeof counterId !== 'string' && typeof counterId !== 'number') {
        throw new Error("Call to SectionModel.getCounterServices requires counterId argument that is either a string or a number.");
      }

      if (cbIsFunc) {
        this.fetchCounterData(counterId, function (data) {
          cd = data;
          if (cd) {
            callback(cd.service_ids);
          }
        });
      }

      if (this.countersData) {
        cd = this.getCounter(counterId);
        if (cd) {
          response = cd.service_ids;
        }
      }

      return response;
    },




    fetchServicesData: function (callback) {
      var myCallBack,
        url = 'https://' + window.location.hostname + '/_abapi/api/v1/services',
        me = this,
        cbIsFunc = (typeof callback === 'function');

      if (!this.token) {
        throw new Error("Call to SectionModel.fetchServicesData will not work if Authorization Token has not been set first.");
      }
      myCallBack = function (response) {
        me.servicesData = response;
        if (cbIsFunc) {
          callback(response);
        }
        me.fire("services_data", response);
      };

      this.makeAPICall(url, myCallBack);
    },


    getServices: function (callback) {
      var cbIsFunc = (typeof callback === 'function');

      if (this.servicesData) {
        if (cbIsFunc) {
          callback(this.servicesData);
        }
      } else {
        this.fetchServicesData(callback);
      }

      return this.servicesData;  //should return null if servicesData is not populated yet
    },


    /*getService: function (serviceId) {
      var response, sd;

      if (typeof serviceId !== 'string' && typeof serviceId !== 'number') {
        throw new Error("Call to SectionModel.getService requires serviceId argument that is either a string or a number.");
      }
      if (!this.servicesData) {
        throw new Error("Call to SectionModel.getService will not work if a call to fetchServicesData has not been made first.");
      }

      for (var i = this.servicesData.length - 1; i >= 0; i -= 1) {
        sd = this.servicesData[i];
        if (parseInt(sd.id, 10) === parseInt(serviceId, 10)) {
          response = sd;
          break;
        }
      }

      return response;
    },*/

    getService: function (onlineContentId) {
      var response, sd;

      if (typeof onlineContentId !== 'string' && typeof onlineContentId !== 'number') {
        throw new Error("Call to SectionModel.getService requires serviceId argument that is either a string or a number.");
      }
      if (!this.servicesData) {
        throw new Error("Call to SectionModel.getService will not work if a call to fetchServicesData has not been made first.");
      }

      for (var i = this.servicesData.length - 1; i >= 0; i -= 1) {
        sd = this.servicesData[i];
        if (parseInt(sd.online_content_id, 10) === parseInt(onlineContentId, 10)) {
          response = sd;
          break;
        }
      }

      return response;
    },

    bookAppointment: function (params, callback, errorCallback) {
      var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments';
      if (!params || params !== Object(params)) {
        throw new Error("Call to SectionModel.bookAppointment requires params object as first argument.");
      }
      if (Drupal.settings.globals_variables.set_appt_lang) {
        var languageCode = this.getLanguage();
        if (languageCode) {
          params.language_code = languageCode;
        }
        this.apptUrl = url;
        this.apptParams = params;
        this.apptCallback = callback;
        this.apptErrorCallback = errorCallback;
        this.makeAPICall(this.apptUrl, 'POST', this.apptParams, this.apptCallback, this.apptErrorCallback);
      } else {
        this.makeAPICall(url, 'POST', params, callback, errorCallback);
     }
    },

    getLanguage: function() {
      var language_id = null;
      if (tmspageData && tmspageData.tms_page_info && tmspageData.tms_page_info.site_info && tmspageData.tms_page_info.site_info.LANGUAGE_ID) {
        language_id = tmspageData.tms_page_info.site_info.LANGUAGE_ID;
        return language_id;
      }
      return language_id;
    },

    changeAppointment: function (id, params, callback, errorCallback) {
      if (!id) {
        throw new Error("Call to SectionModel.changeAppointment requires id as first argument.");
      }

      var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments/' + id;

      if (!params || params !== Object(params)) {
        throw new Error("Call to SectionModel.bookAppointment requires params object as first argument.");
      }

      params._method = "PUT";

      this.makeAPICall(url, "POST", params, callback, errorCallback);
    },


    cancelAppointment: function (id, token, callback, errorCallback) {
      if (!id) {
        throw new Error("Call to SectionModel.cancelAppointment requires id as first argument.");
      }

      if (!token) {
        throw new Error("Call to SectionModel.cancelAppointment requires token as second argument.");
      }

      var curToken = this.token,
        url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments/' + id,
        me = this;



      function myCallback(r) {
        me.token = curToken;
        if (typeof callback === 'function') {
          callback(r);
        }
      }

      function myErrorCallback(r) {
        me.token = curToken;
        if (typeof errorCallback === 'function') {
          errorCallback(r);
        }
      }
      this.token = token;
      this.makeAPICall(url, "DELETE", myCallback, myErrorCallback);
    },

    getAppointment: function (id, callback, errorCallback) {
      var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments/' + id;

      if (!id) {
        throw new Error("Call to SectionModel.getAppointment requires appointment id as first argument.");
      }

      this.makeAPICall(url, "GET", callback, errorCallback);
    },

    getAppointments: function (callback, errorCallback) {
      var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments';
      this.makeAPICall(url, "GET", callback, errorCallback);
    }
  });

  /**
   * sectionManager is an object that is a concrete view of the sectionModel.
   * It manages which sections display when.
   *
   *
   */

  apptBook.sectionManager = $.extend(Object.create(new ctrlopt.mvc.AbstractView()), {
    initialized: false,
    apptBookContainer: undefined,
    sectionsContainer: undefined,
    sections: undefined,
    publisher: new ctrlopt.Publisher(),

    init: function (sectionsContainer, sections) {
      this.apptBookContainer = $('#appointment-book-container');
      this.sectionsContainer = sectionsContainer;
      //this.sections = sections.remove();
      this.sections = sections.detach();

      return this;
    },

    setUpSections: function () {
      var me = this;

      function findSectData(sectionElem) {
        for (var i = 0, len = me.sectionsData.length; i < len; i += 1) {
          var mySect = sectionElem.find(me.sectionsData[i].jqElem);
          if (mySect.length) {
            return me.sectionsData[i];
          }
        }

        return null;
      }

      this.sections.each(function () {

        var $this = $(this);

        var mySectData = findSectData($this);
        if (mySectData) {
          mySectData.sectionElem = $this;
        }
      });
    },

    goToSection: function () {
      var me = this;

      function transIn() {
        if (me.lastIndex !== me.currentIndex) {
          me.apptBookContainer.addClass(me.sectionsData[me.currentIndex].id);
          me.currentSection.appendTo(me.sectionsContainer);

          // We don't need to fire a tag for step 1 (currentIndex 0) because that has a pageview tag
          // When currentIndex == 4 that is the final confirmation page and needs no tag
          if (me.currentIndex !== 0 && me.currentIndex <= 3) {
            var curStep = me.currentIndex + 1;
            site.track.evtView({
              page_url: '/book-appointment/step' + curStep,
              location: location.origin + '/book-appointment/step' + curStep,
              page_name: 'Book Appointment - Step ' + curStep
            });
          }
        }

        me.currentSection.css('display', 'none');
        me.currentSection.fadeIn(2000, function () {
          me.fire('transition_in_end');
        });
        me.fire('transition_in_start');
      }

      if (this.lastSection) {
        this.lastSection.fadeOut(700, function () {
          transIn();
          window.scrollTo(0, 0);
          if (me.lastIndex !== me.currentIndex) {
            me.lastSection.detach();
            me.apptBookContainer.removeClass(me.sectionsData[me.lastIndex].id);
          }
        });

      } else {
        transIn();
      }
    },

    onUpdate: function (data) {
      var nextSectData;
      if (!this.initialized) {
        this.sectionsData = this.model.getData();
        this.setUpSections();
        this.initialized = true;
      }

      if (data && typeof data.sectionIndex !== "undefined") {
        nextSectData = this.sectionsData[data.sectionIndex];
        if (nextSectData) {
          this.lastSection = this.currentSection;
          this.lastIndex = this.currentIndex;

          this.currentSection = nextSectData.sectionElem;
          this.currentIndex = data.sectionIndex;
          this.goToSection();
        }
      }
    },

    on: function (type, func, context) {
      this.publisher.on(type, func, context);
      return this;
    },

    off: function (type, func, context) {
      this.publisher.off(type, func, context);
      return this;
    },

    fire: function (type, data) {
      this.publisher.fire(type, data);
      return this;
    },

    has: function (type, func, context) {
      return this.publisher.has(type, func, context);
    },

    indexOf: function (type, func, context) {
      return this.publisher.indexOf(type, func, context);
    },

    destroy: function () {
      this.publisher.destroy();
      return this;
    }
  });


/**
   * AbstractApptBookSection is an abstract class that supplies base functionality for concrete views of the
   * ApptBookingModel.
   *
   * @constructor
   */
  apptBook.AbstractSection = function () {
    apptBook.AbstractSection.superclass.constructor.call(this);
    this.initialized = false;

  };
  
  ctrlopt.extend(apptBook.AbstractSection, ctrlopt.mvc.AbstractView);
  
  
  apptBook.AbstractSection.prototype.onUpdate = function(data) {
    //console.log("AbstractApptBookSection onUpdate");
  };

  apptBook.AbstractSection.prototype.defaultController = function() {
    return;
  };


  apptBook.historyHandler = $.extend(Object.create(new ctrlopt.mvc.AbstractController()), {
    initialised: false,
    setModel: function (m) {
      ctrlopt.mvc.AbstractController.prototype.setModel.call(this, m);
      //set up listening for the popstate event
      if (window.history && window.history.pushState) {
        $(window).on('popstate', this.popState.bind(this));
      }
      return this;
    },

    popState: function (e) {
      var updateObj, loc,
        state = e.originalEvent.state,
        sectId = this.model.getSectionData().id;
      if(!state) {
        return;
      }

      if (sectId === 'confirmation') {
        window.location.reload(true);
        return;
      } else {
        updateObj = state.updateObj;
      }

      updateObj.isHistory = true;

      this.model.update(updateObj);
    },

    onUpdate: function (data) {
      var stateObj, loc;
      if ((!window.history || !window.history.pushState) || data.isHistory) {
        return;
      }
      stateObj = {updateObj: data};
      loc = window.location;

      if (this.initialized) {
        history.pushState(stateObj, null, loc);
      } else {
        //var hash = window.location.hash;
        history.replaceState(stateObj, null, loc);
        this.initialized = true;
      }
    }
  });

  apptBook.jumpToServicesForStore = function(store_number) {
    var foundCounterByNumber = apptBook.sectionModel.countersData.filter(function(element) {
      return element.store_no === store_number;
    })[0];
    if (foundCounterByNumber) {
      var updateData = {
        sectionId: 'next',
        params: {
          counterId: foundCounterByNumber.id,
          maxApptDuration: foundCounterByNumber.max_appointment_duration,
          timeSlotInterval: foundCounterByNumber.timeslot_interval,
          updateMode: false
        }
      };
      apptBook.sectionModel.update(updateData);
    }
  };

  apptBook.equalHeights = function($elems) {
    var maxHeight = 0;
    $elems.each(function () {
      var myH = $(this).height();
      if (myH > maxHeight) {
        maxHeight = myH;
      }
    });

    $elems.height(maxHeight);
  };

}(jQuery));




